
import "/app/src/modules/zy-crm/components/referral-section/style.module.less?modules";
export default {"fullWidth": `fullWidth-U5F4xFgb`,"responsiveModal": `responsiveModal-zxdaGENl`}
